export default {
    data: function () {
        return {
            replaceItemSwitch: false
        }
    },
}
